import React from 'react';
import './footer.css'
import logo from '../assets/logo.png'
import google from '../assets/googlestore.png'
import apple from '../assets/applestore.png'
import facebook from '../assets/fb.svg'
import pinterest from '../assets/pinterest.png'
import instagram from '../assets/ig.png'
import logobaru from '../assets/logorealview.png'



const Footer= () =>{
    return(
        <div className='footer'>
            <div className='container'>
                    <div className='footer-row'>
                        <div className='brand'>
                            <div className='brand-logo'>
                                <img className="logo-image" src={logobaru} alt="logo" />
                                {/* <h4>MilanTV</h4> */}
                            </div>
                            <div className="brand-content">
                                <p>
                                    RealView is the No. 1 most popular and authoritative source for Movie. Find ratings and reviews for the newest movie.
                                </p>
                            </div>
                        </div>
                        <div className="footer-link">
                            <p>Tentang Kami</p>
                            <p>Blog</p>
                            <p>Layanan</p>
                            <p>Karir</p>
                            <p>Pusat Media</p>
                        </div>
                        <div className='footer-media'>
                            <div className='download'>
                                <h5>Download</h5>
                                <div className='app-logo'>
                                    <img
                                        className="google"
                                        src={google}
                                        alt="Play Store"
                                    />
                                    <img 
                                        className="apple"
                                        src={apple}
                                        alt="Apple Store"
                                    />
                                </div>
                            </div>
                            <div className='soc-med'> 
                                <h5>Social Media</h5>
                                <div className='soc-med-logo'> 
                                    <img
                                        className="fb"
                                        src={facebook}
                                        alt="Facebook"
                                    />
                                    <img
                                        className="pin"
                                        src={pinterest}
                                        alt="Pinterest"
                                    />
                                    <img
                                        className="ig"
                                        src={instagram}
                                        alt="Instagram"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="copyright">
                        <p>Copyright © 2000-202 MilanTV. All Rights Reserved</p>
                    </div>
            </div>
        </div>
    )
}

export default Footer